<template>
  <div id="distribution_pop_Two">
    <div class="pop_warp pop_flex">
      <div class="pop_box">
        <div class="pop_top">添加学生</div>
        <div class="pop_middle pop_flex">
          <div class="mid_left">
            <div v-if="gradeClassAll" class="left_top pop_flex">
              <a-select style="width: 120px" @change="gradeChange" placeholder="筛选年级" allowClear>
                <a-select-option v-for="(item, index) in editGradeListOne" :key="index + 'a'" :value="item.id">{{item.val}}</a-select-option>
              </a-select>
              <a-select style="width: 120px" @change="classChange" placeholder="筛选班级" allowClear>
                <a-select-option v-for="(item, index) in classChangeList" :key="index + 'b'" :value="item">{{item}}</a-select-option>
              </a-select>
              <a-input v-model="importantInfo" placeholder="姓名/身份证/学籍号" />
              <a-button type="primary" @click="searchHandle">查询</a-button>
            </div>
            <div class="left_foot">
              <a-table :columns="columns" :dataSource="emptyInfo" :rowKey="row => row.UID" :pagination="{ pageSize: 10, showSizeChanger: true, showQuickJumper: true, total: emptyInfo ? stuTotal : 0, current: stuCurrentNum }" :locale="{emptyText: '请搜索学生'}" @change="handTableChange">
                <template slot="SEX" slot-scope="text">{{text === 1 ? '男' : (text === 2 ? '女' : '未知') }}</template>
                <template slot="ENTRYYEAR" slot-scope="text">{{gradeName(text)}}</template>
                <template slot="CLASS_ID" slot-scope="text">{{`${text}班`}}</template>
                <template slot="operation" slot-scope="text, record">
                  <a-checkbox @change="operationHandle(record.UID, record)" :checked="record.checkFlag"></a-checkbox>
                </template>
              </a-table>
            </div>
          </div>
          <div class="mid_right">
            <div class="pop_flex" style=" align-items: center;">
              <img src="@/assets/fill_icon.png" alt="" style="margin-right: 10px;">
              <span>已选择学生</span>
            </div>
            <ul>
              <li v-if="chooseList.length === 0" style="color: #8C8C8C; margin-top: 25px;">暂无已选择学生</li>
              <li v-else v-for="(item, index) in chooseList" :key="index + 'abc'" class="pop_flex list_item">
                <span style="color: #8C8C8C;">{{item.REAL_NAME}}</span>
                <img src="@/assets/remove_icon.png" alt="" style="cursor: pointer;" @click="removeStuHandle(item)">
              </li>
            </ul>
          </div>
        </div>
        <div class="pop_foot pop_flex">
          <a-button @click="updateRemoveHandle" style="margin-right: 8px;">取消</a-button>
          <a-button type="primary" @click="addHandle">添加</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import GradeFormat from '@/util/gradeFormat'
import STUDENTFUN from '@/util/studentFun'

export default {
  name: 'DistributionPopTwo',
  data () {
    return {
      gradeVal: null,
      classVal: null,
      importantInfo: null,
      editGradeListOne: null,
      gradeClassAll: null,
      stuInfoList: null,
      stuTotals: null,
      columns: [
        {
          title: '已选学生',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME'
        },
        {
          title: '性别',
          dataIndex: 'SEX',
          key: 'SEX',
          scopedSlots: { customRender: 'SEX' }
        },
        {
          title: '年级',
          dataIndex: 'ENTRYYEAR',
          key: 'ENTRYYEAR',
          scopedSlots: { customRender: 'ENTRYYEAR' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS_ID',
          key: 'CLASS_ID',
          scopedSlots: { customRender: 'CLASS_ID' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      showStatus: true,
      chooseList: [],
      chooseListNum: [],
      emptyInfo: null
    }
  },
  computed: {
    ...mapState([
      'schoolGrades',
      'schoolInfos',
      'gradeClass',
      'stuTotal',
      'stuCurrentNum',
      'userInfo'
    ]),
    classChangeList () {
      let list = null
      let classList = []
      if (this.gradeVal) {
        const arr = this.gradeClass.filter(item => item.ENTRYYEAR === this.gradeVal)
        if (arr.length) {
          arr.map(item => {
            classList.push(`${item.CLASS_ID}班`)
          })
          classList.sort((a, b) => parseInt(a) - parseInt(b))
          list = classList
        }
      } else {
        list = this.gradeClassAll.classArr
      }
      return list
    }
  },
  async mounted () {
    // await this.getGradeClass()
    if (this.schoolInfos) {
      this.stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.stuInfoList.map(item => {
        item.checkFlag = false
      })
      // this.stuTotals = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.gradeClassAll = STUDENTFUN.uploadData(this.stuInfoList)
    }
    if (this.schoolGrades) {
      this.editGradeListOne = STUDENTFUN.editGradeReplaceOne(this.schoolGrades, this.userInfo.SCHOOL_TYPE)
    }
  },
  watch: {
    async schoolInfos () {
      this.stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.stuInfoList.map(item => {
        item.checkFlag = false
      })
      this.emptyInfo = this.stuInfoList
      // this.stuTotals = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
      this.gradeClassAll = STUDENTFUN.uploadData(this.stuInfoList)
    }
  },
  methods: {
    ...mapMutations([
      'setPopTwoShow',
      'setStuCurrentNum'
    ]),
    ...mapActions([
      'getSchoolInfos'
      // 'getGradeClass'
    ]),
    updateRemoveHandle () { // 取消按钮
      this.setPopTwoShow(false)
    },
    addHandle () { // 添加按钮
      this.$emit('chooseHandle', {chooseList: this.chooseList, chooseListNum: this.chooseListNum})
      this.setPopTwoShow(false)
    },
    gradeChange (value) { // 筛选年级
      this.gradeVal = value
    },
    classChange (value) { // 筛选班级
      this.classVal = value
    },
    async searchHandle () { // 查询
      if (this.classVal && !this.gradeVal) {
        this.$message.error('必须先选择年级才能搜索班级！')
      } else {
        let obj = {}
        if (this.gradeVal) {
          obj['ENTRYYEAR'] = this.gradeVal
          obj['hide'] = true
        } else {
          obj['hide'] = false
        }
        console.log(this.classVal)
        this.classVal ? obj['CLASS_ID'] = this.classVal.slice(0, this.classVal.length - 1) : true
        this.importantInfo ? obj['SEARCH'] = this.importantInfo : true
        obj['skip'] = 0
        await this.getSchoolInfos(obj)
        this.setStuCurrentNum(1)
        this.emptyInfo = this.stuInfoList.filter((item) => !this.gradeVal ? true : item.ENTRYYEAR === parseInt(this.gradeVal)).filter((item) => !this.classVal ? true : item.CLASS_ID === this.classVal.slice(0, this.classVal.length - 1)).filter((item) => !this.importantInfo ? true : item.REAL_NAME.indexOf(this.importantInfo) !== -1 || (item.STUDENT_ID_CARD ? item.STUDENT_ID_CARD.indexOf(this.importantInfo) !== -1 : '') || (item.STUDENT_ID_SOCIAL ? item.STUDENT_ID_SOCIAL.indexOf(this.importantInfo) !== -1 : ''))
      }
      // this.emptyInfo = this.stuInfoList
      // this.emptyInfo = this.stuTotals.filter((item) => !this.gradeVal ? true : item.ENTRYYEAR === parseInt(this.gradeVal)).filter((item) => !this.classVal ? true : item.CLASS_ID === parseInt(this.classVal)).filter((item) => !this.importantInfo ? true : item.REAL_NAME.indexOf(this.importantInfo) !== -1 || (item.STUDENT_ID_CARD ? item.STUDENT_ID_CARD.indexOf(this.importantInfo) !== -1 : '') || (item.STUDENT_ID_SOCIAL ? item.STUDENT_ID_SOCIAL.indexOf(this.importantInfo) !== -1 : ''))
    },
    operationHandle (key, value) { // 设置分配范围中删除所选学生的功能
      if (this.chooseListNum.includes(key)) {
        this.stuInfoList.map(tag => {
          if (tag.UID === key) {
            tag.checkFlag = false
          }
        })
        const list = this.chooseList.filter(tag => tag.UID !== key)
        const listTwo = this.chooseListNum.filter(tag => tag !== key)
        this.chooseList = list
        this.chooseListNum = listTwo
      } else {
        this.stuInfoList.map(tag => {
          if (tag.UID === key) {
            tag.checkFlag = true
          }
        })
        this.checkFlag = true
        this.chooseList.push(value)
        this.chooseListNum.push(key)
      }
    },
    gradeName (item) { // 转换年级
      return GradeFormat(item, this.userInfo.SCHOOL_TYPE)
    },
    removeStuHandle (value) { // 已选列表中删除学生
      this.stuInfoList.map(tag => {
        if (tag.UID === value.UID) {
          tag.checkFlag = false
        }
      })
      const list = this.chooseList.filter(tag => tag.UID !== value.UID)
      const listTwo = this.chooseListNum.filter(tag => tag !== value.UID)
      this.chooseList = list
      this.chooseListNum = listTwo
    },
    deleteHandle (key, value) {
      this.operationHandle(key, value)
    },
    async handTableChange (info) {
      this.setStuCurrentNum(info.current)
      if (!this.gradeVal && !this.classVal && !this.importantInfo) {
        await this.getSchoolInfos({skip: (info.current - 1) * 10})
      } else {
        let obj = {}
        if (this.gradeVal) {
          obj['ENTRYYEAR'] = this.gradeVal
          obj['hide'] = true
        } else {
          obj['hide'] = false
        }
        this.classVal ? obj['CLASS_ID'] = parseInt(this.classVal) : true
        this.importantInfo ? obj['SEARCH'] = this.importantInfo : true
        obj['skip'] = (info.current - 1) * 10
        await this.getSchoolInfos(obj)
      }
    }
  }
}
</script>

<style>
#distribution_pop_Two {
  position: fixed;
  z-index: 1000;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, .4);
  color: #262626;
  overflow-y: auto;
}
#distribution_pop_Two .pop_flex {
  display: flex;
}
#distribution_pop_Two .pop_warp {
  width: 100%;
  padding: 140px 0px;
  box-sizing: border-box;
  height: auto;
  justify-content: center;
}
#distribution_pop_Two .pop_box {
  width: 1000px;
  background-color: #FFFFFF;
  border-radius: 4px;
}
#distribution_pop_Two .pop_box .pop_top {
  padding: 16px 24px;
  border-bottom: 1px solid #EBEBEB;
  box-sizing: border-box;
  font-size: 16px;
}
#distribution_pop_Two .pop_box .pop_middle {
  width: 100%;
}
#distribution_pop_Two .pop_box .pop_foot {
  padding: 16px;
  border-top: 1px solid #EBEBEB;
  box-sizing: border-box;
  justify-content: flex-end;
}
#distribution_pop_Two .mid_left {
  flex-basis: 72%;
}
#distribution_pop_Two .mid_left .left_top {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
}
#distribution_pop_Two .mid_left .left_top .ant-select {
  margin-right: 16px;
}
#distribution_pop_Two .mid_left .left_top .ant-input {
  width: 180px;
  margin-right: 16px;
}
#distribution_pop_Two .mid_right {
  flex-basis: 28%;
  background-color: #F5F5F5;
  padding: 25px;
  box-sizing: border-box;
}
#distribution_pop_Two .mid_right ul {
  overflow-y: scroll;
  padding: 0px;
  margin: 0px;
  max-height: 650px;
}
#distribution_pop_Two .mid_right ul .list_item {
  align-items: center;
  justify-content: space-between;
  margin-top: 26px
}
#distribution_pop_Two .mid_left .left_foot {
  min-height: 500px;
}
</style>
